import { Grid } from './../../../../../app/core/components/grid/grid.model';

(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('multiProductCalc', {
        templateUrl: 'views/components/views/multiProductCalc/multiProductCalc.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: [
            'stateService',
            'utilityService',
            'modalService',
            'multiProductCalcService',
            'logisticService',
            'economyService',
            'ttGridFactory',
            'rememberService',
            'productService',
            'tsModalService',
            function (stateService, utilityService, modalService, multiProductCalcService, logisticService, economyService, ttGridFactory, rememberService, productService, tsModalService) {
                // #region VARIABLES & DEFINITIONS

                const vm = this;

                let variableNames = {
                    gb_multiproductcalc_main: '',
                    businessco_no: '',
                    stockplace_id: '',
                    pricelist_id: '',
                    pricelist_id_selection: '',
                    assortment_keyno: '',
                    prodtype_no: '',
                    searchtext: '',
                    limit_search_results: '',
                    onlyonstock: '',
                };

                vm.model = {
                    gridPerformCalculationReady: false,
                    gridCalculationResultReady: false,
                    pricelistSelectionButtons: [{ id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('pricelist_id_selection') }],
                    pricelistButtons: [{ id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('pricelist_id') }],
                    assortmentButtons: [{ id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('assortment_keyno') }],
                    prodtypeButtons: [{ id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('prodtype_no') }],
                    searchTextButtons: [
                        { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('searchtext') },
                        { id: 'calculator', icon: 'fa fa-calculator', color: 'primary', type: 'primary', onClick: () => openCalculator('searchtext') },
                        { id: 'search', icon: 'fas fa-search', color: 'primary', type: 'primary', onClick: () => searchGrid() },
                    ],
                    bgMultiProductCalcMain: {
                        selected: 'CALCULATION',
                        buttons: [
                            { id: 'CALCULATION', label: 'gb_multiproductcalc_main_calculation', color: 'primary', onClick: () => setMultiProductCalcMainView('CALCULATION') },
                            { id: 'RESULT', label: 'gb_multiproductcalc_main_result', color: 'primary', onClick: () => setMultiProductCalcMainView('RESULT') },
                        ],
                    },
                    setting: {},
                    selectListCompanies: [],
                    selectListPrices: [],
                    selectListStockPlaces: [],
                    selectListAssortments: [],
                    selectListProdtypes: [],
                };

                // vm.gridPerformCalculation = new ttGridFactory({
                //     rememberId: 'w_multiproductcalc_selection_grid',
                //     kendo: {
                //         height: '100%',
                //         sortable: true,
                //         aggregate: true,
                //         pager: false,
                //         selectable: false,
                //         filterable: false,
                //     },
                // }).setToolbar({ wrapping: true });

                vm.calculating = false;

                vm.gridPerformCalculation = new Grid()
                    .setRememberId('w_multiproductcalc_selection_grid')
                    .setLoadDataFunction({ method: 3861, parameters: () => vm.model.setting })
                    .addToolbarButton({ name: 'productsearch_calculation2', text: 'productsearch_calculation', icon: 'fal fa-calculator', cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r', func: calculateProducts, spinOnAction: true, disabled: () => vm.calculating === true || (vm.gridPerformCalculation?.gridfunc?.getIsSelectedRows()?.length ?? 0) === 0 });

                vm.gridCalculationResult = new ttGridFactory({
                    rememberId: 'w_multiproductcalc_result_grid',
                    kendo: {
                        height: '100%',
                        sortable: true,
                        aggregate: true,
                        pager: false,
                        selectable: false,
                        filterable: false,
                    },
                }).setToolbar({ wrapping: true });

                async function calculateProducts() {
                    const selectedRows = vm.gridPerformCalculation.gridfunc?.getIsSelectedRows() ?? [];

                    if (selectedRows.length === 0) return;

                    vm.calculating = true;
                    vm.gridPerformCalculation.gridfunc?.refreshToolbarBtnDisability();

                    try {
                        const response = await multiProductCalcService.getSelectedVariants({ datatask: 3861, isSelected: selectedRows, parameters: vm.model.setting, rows: [] });
                        let count = 0;

                        /**
                         * @type {import ('../../../../../app/core/components/grid/modals/progress-modal/progress-modal.component').ProgressModalData}
                         */
                        const modalOptions = {
                            value: count,
                            max: response.length,
                        };

                        /**
                         * @type {import ('../../../../../app/core/components/grid/modals/progress-modal/progress-modal.component').ProgressModalComponent}
                         */
                        const progressModal = tsModalService.openProgressDialog(modalOptions);

                        for (let variant of response) {
                            const { errorcode, errormessage } = await multiProductCalcService.calculateSelectedVariant(variant);

                            if ('' + errorcode !== '0') {
                                progressModal.updateStatus('invalid');
                                progressModal.updateInvalidText(errormessage);
                            } else {
                                count = count + 1;
                                progressModal.updateValue(count);
                            }
                        }

                        await vm.gridPerformCalculation.gridfunc?.read();

                        if (count === response.length) {
                            progressModal.updateStatus('finish');
                            progressModal.dialogRef.close();
                        }
                    } finally {
                        vm.calculating = false;
                        vm.gridPerformCalculation.gridfunc?.refreshToolbarBtnDisability();
                    }
                }

                // #endregion VARIABLES & DEFINITIONS

                // #region SET BUTTON RADIO VALUE FUNCTIONS

                function setMultiProductCalcMainView(id) {
                    vm.model.bgMultiProductCalcMain.selected = vm.model.setting.gb_multiproductcalc_main = id;
                }

                // #endregion SET BUTTON RADIO VALUE FUNCTIONS

                // #region LOAD PROCEDURE FUNCTION CALLS

                async function loadSetting() {
                    vm.model.setting = (await multiProductCalcService.getSetting())[0];
                }

                async function loadCompanies() {
                    vm.model.selectListCompanies = await logisticService.listCompanies();
                }

                async function loadPrices() {
                    vm.model.selectListPrices = await economyService.listPrices();
                }

                async function loadStockPlaces() {
                    if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;

                    return (vm.model.selectListStockPlaces = await logisticService.listStocks({ businessco_no: vm.model.setting.businessco_no }));
                }

                async function loadAssortments() {
                    vm.model.selectListAssortments = await productService.listAssortments();
                }

                async function loadProdtypes() {
                    vm.model.selectListProdtypes = await productService.listProductTypes();
                }

                // #endregion LOAD PROCEDURE FUNCTION CALLS

                // #region GRID PROCEDURE FUNCTION CALLS

                async function loadGridPerformCalculation() {
                    vm.gridPerformCalculation.dataTask.loadData = {
                        method: 3861,
                        parameters: vm.model.setting,
                    };

                    vm.model.gridPerformCalculationReady = true;

                    if (vm.gridPerformCalculation.gridfunc !== null) vm.gridPerformCalculation.gridfunc.read();
                }

                async function loadGridCalculationResult() {
                    vm.gridCalculationResult.dataTask.loadData = {
                        method: 3862,
                        parameters: vm.model.setting,
                    };

                    vm.model.gridCalculationResultReady = true;

                    if (vm.gridCalculationResult.gridfunc !== null) vm.gridCalculationResult.gridfunc.read();
                }

                // #endregion GRID PROCEDURE FUNCTION CALLS

                // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

                function rememberFunc(id) {
                    Object.keys(variableNames).forEach((key) => {
                        switch (key) {
                            case '':
                                break;
                            default:
                                variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
                                break;
                        }
                    });

                    if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

                    let variableValue = null;

                    switch (id) {
                        case 'gb_multiproductcalc_main':
                        case 'businessco_no':
                            if (utilityService.validateParmsValue(vm.model.setting[id]) !== true) return;

                            variableValue = vm.model.setting[id];
                            break;
                        case 'stockplace_id':
                        case 'pricelist_id':
                        case 'pricelist_id_selection':
                        case 'searchtext':
                        case 'assortment_keyno':
                        case 'prodtype_no':
                        case 'limit_search_results':
                        case 'onlyonstock':
                            if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

                            variableValue = vm.model.setting[id];
                            break;
                        default:
                            break;
                    }

                    return rememberService.remember(variableNames[id], variableValue);
                }

                // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

                // #region CLEAR SEARCH GRID FUNCTION

                async function clearSearchGrid() {
                    if (vm.model.setting.searchtext === '') {
                        rememberFunc('searchtext');
                        await loadGridPerformCalculation();
                        await loadGridCalculationResult();
                    }
                }

                // #endregion CLEAR SEARCH GRID FUNCTION

                // #region SEARCH GRID FUNCTION

                async function searchGrid() {
                    if (vm.model.setting.searchtext > '') {
                        rememberFunc('searchtext');
                        await loadGridPerformCalculation();
                        await loadGridCalculationResult();
                    }
                }

                // #endregion SEARCH GRID FUNCTION

                // #region CLEAR BUTTON FUNCTION

                function clear(id) {
                    switch (id) {
                        case 'pricelist_id_selection':
                        case 'pricelist_id':
                        case 'assortment_keyno':
                        case 'prodtype_no':
                            vm.model.setting[id] = '';

                            if (vm.model.setting[id] === '') {
                                rememberFunc(id);
                                loadGridPerformCalculation();
                                loadGridCalculationResult();
                            }
                            break;
                        case 'searchtext':
                            vm.model.setting.searchtext = '';

                            clearSearchGrid();
                            break;
                        default:
                            break;
                    }
                }

                // #endregion CLEAR BUTTON FUNCTION

                // #region OPEN CALCULATOR DIALOGUE BOX FUNCTION

                function openCalculator(id) {
                    modalService.showCalculator(vm.model.setting[id]).then(function (value) {
                        vm.model.setting[id] = value;

                        searchGrid();
                    });
                }

                // #endregion OPEN CALCULATOR DIALOGUE BOX FUNCTION

                // #region SEARCH ENTER FUNCTION

                vm.searchItems = function () {
                    searchGrid();
                };

                // #endregion SEARCH ENTER FUNCTION

                // #region BUTTON RADIO FUNCTIONS

                vm.selectBgMultiProductCalcMain = function (value) {
                    vm.model.bgMultiProductCalcMain.selected = value;
                    vm.model.setting.gb_multiproductcalc_main = vm.model.bgMultiProductCalcMain.selected;

                    rememberFunc('gb_multiproductcalc_main');
                };

                // #endregion BUTTON RADIO FUNCTIONS

                // #region FIELD CHANGE MULTI FUNCTIONS

                vm.onChanged = async function (value, id) {
                    switch (id) {
                        case 'businessco_no':
                            if (utilityService.validateWatchValue(value, vm.model.setting.businessco_no) !== true) return;

                            vm.model.setting.businessco_no = value;

                            if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;

                            rememberFunc('businessco_no');
                            await loadGridPerformCalculation();
                            await loadGridCalculationResult();
                            break;
                        case 'stockplace_id':
                            if (utilityService.validateWatchValue(value, vm.model.setting.stockplace_id) !== true) return;

                            vm.model.setting.stockplace_id = value;

                            if (utilityService.validateParmsValue(vm.model.setting.stockplace_id, true) !== true) return;

                            rememberFunc('stockplace_id');
                            await loadGridPerformCalculation();
                            await loadGridCalculationResult();
                            break;
                        case 'pricelist_id':
                            if (utilityService.validateWatchValue(value, vm.model.setting.pricelist_id) !== true) return;

                            vm.model.setting.pricelist_id = value;

                            if (utilityService.validateParmsValue(vm.model.setting.pricelist_id, true) !== true) return;

                            rememberFunc('pricelist_id');
                            await loadGridPerformCalculation();
                            await loadGridCalculationResult();
                            break;
                        case 'pricelist_id_selection':
                            if (utilityService.validateWatchValue(value, vm.model.setting.pricelist_id_selection) !== true) return;

                            vm.model.setting.pricelist_id_selection = value;

                            if (utilityService.validateParmsValue(vm.model.setting.pricelist_id_selection, true) !== true) return;

                            rememberFunc('pricelist_id_selection');
                            await loadGridPerformCalculation();
                            await loadGridCalculationResult();
                            break;
                        case 'assortment_keyno':
                            if (utilityService.validateWatchValue(value, vm.model.setting.assortment_keyno) !== true) return;

                            vm.model.setting.assortment_keyno = value;

                            if (utilityService.validateParmsValue(vm.model.setting.assortment_keyno, true) !== true) return;

                            rememberFunc('assortment_keyno');
                            await loadGridPerformCalculation();
                            await loadGridCalculationResult();
                            break;
                        case 'prodtype_no':
                            if (utilityService.validateWatchValue(value, vm.model.setting.prodtype_no) !== true) return;

                            vm.model.setting.prodtype_no = value;

                            if (utilityService.validateParmsValue(vm.model.setting.prodtype_no, true) !== true) return;

                            rememberFunc('prodtype_no');
                            await loadGridPerformCalculation();
                            await loadGridCalculationResult();
                            break;
                        case 'limit_search_results':
                            if (utilityService.validateWatchValue(value, vm.model.setting.limit_search_results) !== true) return;

                            vm.model.setting.limit_search_results = value;

                            if (utilityService.validateParmsValue(vm.model.setting.limit_search_results, true) !== true) return;

                            rememberFunc('limit_search_results');
                            await loadGridPerformCalculation();
                            await loadGridCalculationResult();
                            break;
                        case 'searchtext':
                            if (utilityService.validateWatchValue(value, vm.model.setting.searchtext) !== true) return;

                            vm.model.setting.searchtext = value;

                            if (utilityService.validateParmsValue(vm.model.setting.searchtext, true) !== true) return;

                            clearSearchGrid();
                            break;
                        case 'onlyonstock':
                            // if (utilityService.validateWatchValue(value, vm.model.setting.onlyonstock) !== true) return;

                            vm.model.setting.onlyonstock = value;

                            // if (utilityService.validateParmsValue(vm.model.setting.onlyonstock, true) !== true) return;

                            rememberFunc('onlyonstock');
                            await loadGridPerformCalculation();
                            await loadGridCalculationResult();
                            break;
                        default:
                            utilityService.setValueToVariable(value);
                            break;
                    }
                };

                // #endregion FIELD CHANGE MULTI FUNCTIONS

                // #region ON INIT FUNCTION

                vm.$onInit = async function () {
                    await loadSetting();

                    setMultiProductCalcMainView(vm.model.setting.gb_multiproductcalc_main);

                    loadCompanies();
                    loadPrices();
                    loadStockPlaces();
                    loadAssortments();
                    loadProdtypes();
                    loadGridPerformCalculation();
                    loadGridCalculationResult();
                };

                // #endregion ON INIT FUNCTION
            },
        ],
    });
})();
